module.exports = __webpack_public_path__ + "static/media/HARTVIG EVOLUTION TURNTABLE.aa07f5db.png";